import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      message: 'Authenticator service is temporarily unavailable. (500)',
      code: 'SERVER_ERROR',
    }
  }
  if (isStatusOK(data) && data?.data?.responseStatus?.code === '000') {
    return data.data.responseObject
  } else {
    // throw getNetworkResponseError(data?.data)
    const errorBody = data?.data || data || { message: 'Failed to fetch authenticator list' }
    throw getNetworkResponseError(errorBody)
  }
}
export const getAuthenticatorList = (tokens: any, data: { productId: number }) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const requestBody = {
    product: {
      id: data.productId,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
    },
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.getAuthenticatorList,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to respponse parse')
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
